import { render } from "./ItemsSixView.vue?vue&type=template&id=285863d9&scoped=true"
import script from "./ItemsSixView.vue?vue&type=script&lang=js"
export * from "./ItemsSixView.vue?vue&type=script&lang=js"

import "./ItemsSixView.vue?vue&type=style&index=0&id=285863d9&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285863d9"]])

export default __exports__